var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#060A21",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9802 12.9561C25.995 15.1808 23.6433 16.5897 21.691 15.4922C21.2325 15.2401 20.9219 15.2549 20.4929 15.4922C19.1174 16.2486 17.7123 16.9457 16.3368 17.7021C16.115 17.8207 15.8339 18.1025 15.8487 18.3101C15.8487 18.5029 16.1593 18.7551 16.3812 18.8737C17.6975 19.5411 19.0287 20.1789 20.3303 20.8463C20.7148 21.0391 20.9958 21.0687 21.3804 20.7721C22.4453 19.9712 23.8652 20.0157 24.8709 20.8018C25.8767 21.5878 26.2612 22.9226 25.8175 24.1091C25.359 25.3549 24.2202 26.0817 22.8742 25.9927C21.5874 25.9185 20.5225 25.0286 20.2711 23.679C20.1676 23.1748 19.9605 22.9226 19.5316 22.715C18.0821 22.0328 16.677 21.2912 15.2275 20.6238C14.9613 20.5051 14.562 20.5051 14.2957 20.6238C12.8906 21.2615 11.382 20.9204 10.539 19.7339C9.72547 18.5919 9.8438 17.005 10.82 15.9965C11.8109 14.9731 13.3639 14.81 14.5915 15.6702C14.9613 15.9372 15.2275 15.9075 15.5825 15.7147C16.9284 14.988 18.2744 14.2761 19.6351 13.5938C20.0344 13.401 20.1823 13.1637 20.2119 12.704C20.3155 11.1022 21.6762 9.91571 23.2292 10.0047C24.7674 10.1382 25.9654 11.3988 25.9802 12.9561Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "#999BA5",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon);
export default __webpack_public_path__ + "static/media/SocialIcon.dd26b597.svg";
export { ForwardRef as ReactComponent };